module.exports = __webpack_public_path__ + "img/emoji-laughing.52dee75e.svg";